import React from 'react';
import moment from 'moment';
import { getDollarFormat } from 'utils/helpers';
import NoDataMsg from 'library/noData';

const Body = ({ transactionSalesSummary, endDate, beginDate }) => (

    <div>
    {
        transactionSalesSummary && transactionSalesSummary.length <= 0 ? 
        //If there's NO DATA to display
        <NoDataMsg/>
         : 
        //If there's DATA
        <div>
            <div className="row m-0">
                <div className="text-center list_header">
                    {beginDate ? 
                    <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                        { endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b>: moment().format('MMMM Do, YYYY')}</p>
                    : ""}
                </div>
            </div>
            <div className="table-responsive">
                <div className="row m-0 mb-2  text-center" >
                    <div className="col-lg-12 title_summary">
                        <h3 className="m-0 text-center text-justify">SUMMARY</h3>
                    </div>{/* row - Date */}

                    <div className="col-lg-4 col-md-4 col-sm-6 col-xs-6 col-md- m-0 p-0 m-0 p-0">
                        {/* <div className="table_icon"><ActionCreditCard/></div> */}
                        <label className='purpleText'>Total # of Transactions</label>
                        <h3 className="m-0 purple-text">{transactionSalesSummary.totalTransactionNumber}</h3>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-6 col-xs-6 col-md- m-0 p-0 m-0 p-0">
                        {/* <div className="table_icon"><ActionCreditCard/></div> */}
                        <label className='purpleText'>Avg. Transaction Amount</label>
                        <h3 className="m-0 purple-text">{getDollarFormat(transactionSalesSummary.totalTransactionAmount/transactionSalesSummary.totalTransactionNumber)}</h3>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-6 col-xs-6 col-md- m-0 p-0 m-0 p-0">
                        {/* <div className="table_icon"><ActionCreditCard/></div> */}
                        <label className='purpleText'>Avg. Transaction Amount (Non-Including Tax)</label>
                        <h3 className="m-0 purple-text">{getDollarFormat(transactionSalesSummary.totalTransactionAmountSubTotalIncludingDiscounts/transactionSalesSummary.totalTransactionNumber)}</h3>
                    </div>
                    </div>
                </div>
                {
                    transactionSalesSummary && transactionSalesSummary.list && transactionSalesSummary.list.map((item, index) => {
                        return(
                            <div className="row m-0 mb-2" key={index}>
                                <div className="col-lg-12 title_th">
                                    <h3 className="m-0">{moment(item.date).format('MMMM Do, YYYY')}</h3>
                                </div>{/* row - Date */}

                                <div className="col-lg-4 col-md-4 col-sm-6 col-xs-6 col-md- text-center">
                                    <label className='purpleText'>Transaction Count</label>
                                    <h3 className="m-0 grey-text size_2vmax ">{item.transactionCount}</h3>
                                </div> {/* Column Orders */}

                                <div className="col-lg-4 col-md-4 col-sm-6 col-xs-6 col-md- text-center">
                                    {/* <div className="table_icon"><ActionCardGiftcard/></div> */}
                                    <label className='purpleText'>Avg. Transaction <br/>Amount</label>
                                    <h3 className="m-0 green-text"><strong>{getDollarFormat(item.transactionTotal/item.transactionCount)}</strong></h3>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-6 col-xs-6 col-md- text-center">
                                    {/* <div className="table_icon"><ActionCardGiftcard/></div> */}
                                    <label className='purpleText'>Avg. Transaction (Non-Including Tax)<br/>Amount</label>
                                    <h3 className="m-0 green-text"><strong>{getDollarFormat(item.transactionSubtotalIncludingDiscounts/item.transactionCount)}</strong></h3>
                                </div>
                            </div>
                        );
                    })
                }
            </div>
        }
    </div>
);

export default Body;